import { ResendOtpOption } from '../entities/ResendOtpOption';

export const OTP_CONFIG = {
  MIN_CHAR_LENGTH: 0,
  MAX_CHAR_LENGTH: 6,
  RESEND_TIMER: 10, // seconds
  MAX_RESEND_ATTEMPTS: 3,
  NUMERIC_REGEX: /^\d*$/,
  TIMER_INTERVAL: 1000,
};

export const RESEND_OTP_CONFIG = {
  DEFAULT_OPTION: 'SMS' as ResendOtpOption,
};
